import React from "react";
import BlogFourteen from "../component/BlogFourteen";

function BlogFourteenContainer() {
  return <BlogFourteen />;
}
export default BlogFourteenContainer;
